<template>
  <div :id="name">
    <router-view />
    <notifications group="formGroup" position="bottom right" />
    <Loading />
  </div>
</template>

<script>
  import config from '@/config';
  import Loading from '@/components/Loading.vue'
  export default {
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: config.app_title,
    },
    components: {
      Loading
    },
      data(){
        return {
            name : (new Date()).getTime()
        }
      }
  }
</script>

<style lang="scss">
  @import "./styles/scss/app";
</style>